// src/components/social_login/LinkedInLoginButton.tsx
import SocialLoginButton from "./SocialLoginButton";
import { useTranslation } from "../../i18n";

export default function LinkedInLoginButton() {
  const { t } = useTranslation();
  const handleLogin = () => {
    const clientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID!;
    const redirectUri = `${window.location.origin}/linkedin`;
    const state = crypto.randomUUID();
    sessionStorage.setItem("linkedin_oauth_state", state);

    const authUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=openid%20profile%20email&state=${state}`;

    window.location.href = authUrl;
  };

  return (
    <SocialLoginButton
      logoSrc="/linkedin_icon.png"
      alt="LinkedIn"
      text={t("auth.sign_in_linkedin", "Sign in with LinkedIn")}
      onClick={handleLogin}
    />
  );
}
